import PageHeader from "../components/PageHeader";
import EnquiryForm from "../components/EnquiryForm";
import { Reveal } from "../components/Reveal";
import { CONTACT, whatsappLink } from "../data/content";

export default function Contact() {
  return (
    <>
      <PageHeader
        testid="contact-page-header"
        overline="Contact"
        title={["Tell us about", "your site."]}
        intro="Share a few details and our design team will reply within one working day — or reach us directly on WhatsApp, phone or email."
      />

      <section className="container-lux pb-28" data-testid="contact-section">
        <div className="grid gap-14 lg:grid-cols-2">
          <Reveal>
            <div className="space-y-8">
              <div>
                <p className="overline-label">Studio</p>
                <p className="mt-3 text-[15px] font-light leading-relaxed text-ink" data-testid="contact-address">
                  {CONTACT.address}
                </p>
                <p className="mt-1 text-[13px] text-stone-500">{CONTACT.hours}</p>
              </div>

              <div>
                <p className="overline-label">Direct</p>
                <ul className="mt-3 space-y-3 text-[15px]">
                  <li>
                    <a
                      href={`tel:+${CONTACT.whatsapp}`}
                      data-testid="contact-phone-link"
                      className="link-line text-ink"
                    >
                      {CONTACT.phoneDisplay}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`mailto:${CONTACT.email}`}
                      data-testid="contact-email-link"
                      className="link-line text-ink"
                    >
                      {CONTACT.email}
                    </a>
                  </li>
                </ul>
              </div>

              <a
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-button"
                className="inline-flex items-center gap-3 bg-[#25D366] text-white px-7 py-3.5 text-[13px] font-medium tracking-[0.12em] uppercase transition-all duration-500 hover:-translate-y-0.5 hover:shadow-lg"
              >
                <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                Chat on WhatsApp
              </a>

              <div className="border-t border-bronze/15 pt-8">
                <p className="overline-label">Consultations</p>
                <p className="mt-3 max-w-sm text-[14px] font-light leading-relaxed text-stone-warm">
                  Studio consultations are complimentary for projects above ₹25
                  lakh. Site visits across Hyderabad within three working days.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="bg-white border border-bronze/10 p-7 sm:p-10 shadow-[0_30px_60px_-30px_rgba(28,25,23,0.25)]">
              <p className="font-serif text-2xl text-ink mb-2">Enquiry form</p>
              <p className="text-[13px] font-light text-stone-warm mb-8">
                Every enquiry lands directly with the design team.
              </p>
              <EnquiryForm />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
